"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSize5xlarge = exports.fontSize4xlarge = exports.fontSize3xlarge = exports.fontSize2xlarge = exports.fontSizeXlarge = exports.fontSizeLarge = exports.fontSizeMedium = exports.fontSizeSmall = exports.fontSizeXsmall = exports.fontSizeTiny = exports.fontSizeMini = void 0;
exports.fontSizeMini = 8;
exports.fontSizeTiny = 10;
exports.fontSizeXsmall = 12;
exports.fontSizeSmall = 14;
exports.fontSizeMedium = 16;
exports.fontSizeLarge = 20;
exports.fontSizeXlarge = 24;
exports.fontSize2xlarge = 30;
exports.fontSize3xlarge = 40;
exports.fontSize4xlarge = 48;
exports.fontSize5xlarge = 56;